//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { CMSService } from '~/services/storyBlok/cmsService';
import TopBanner from '~/components/about-us/TopBanner.vue';
import WeMakeItFun from '~/components/about-us/WeMakeItFun.vue';
import OriginStory from '~/components/about-us/OriginStory.vue';
import Values from '~/components/about-us/Values.vue';
import Founders from '~/components/about-us/Founders.vue';
import StayInTheKnow from '~/components/about-us/StayInTheKnow.vue';
import { metaData } from '~/configuration/metaData';
import { findComponent, findAllComponents } from '~/selectors/selectorsHelpers';

export default {
  name: 'AboutUs',
  head: {
    ...metaData.aboutUs,
  },
  components: {
    TopBanner,
    WeMakeItFun,
    OriginStory,
    Values,
    Founders,
    StayInTheKnow,
  },
  async asyncData({ $storyapi, error }) {
    const storyBlok = new CMSService({ cmsService: $storyapi });
    let storyResp = [];
    let storyRespId;

    await storyBlok
      .get('about-us')
      .then((resp) => {
        storyRespId = resp.data.story.id;
        storyResp = resp.data.story.content;
      })
      .catch((err) => {
        error({ message: err.message });
      });
    return { storyResp, storyRespId };
  },
  computed: {
    ...mapGetters([
      'isInStoryblok',
    ]),
    getBanner() {
      const exp = findAllComponents({ name: 'Experiment', cmsArray: this.storyResp?.body });
      const isExp = exp ? exp.filter(test => test?.body[0]?.component === 'Banner') : false;

      if (isExp.length) {
        return exp;
      }

      const component = findComponent({ name: 'Banner', cmsArray: this.storyResp?.body });
      return component ? [component] : [];
    },
  },
  mounted() {
    if (this.isInStoryblok) {
      this.$storybridge(
        () => {
          const { StoryblokBridge } = window;
          if (StoryblokBridge != null) {
            const storyblokInstance = new StoryblokBridge();
            storyblokInstance.on(['input', 'published', 'change'], (event) => {
              if (event.action === 'input') {
                if (event.story.id === this.storyRespId) {
                  this.storyResp.body = event.story.content.body;
                }
              } else {
                window.location.reload();
              }
            });
          }
        },
        (error) => {
          console.error(error);
        },
      );
    }
  },
};
